'use client';

import { Dropdown } from '@app/app/_components/Dropdown/Dropdown';
import { useAppParameters } from '@app/app/_context/AppParametersContext/useAppParameters';
import { setLocale } from '@app/service/i18n/actions/setLocale';
import { useLocale, useTranslations } from 'next-intl';
import { useCallback } from 'react';

interface Props {
    align?: 'right' | 'left';
}

export function LanguageSelector({ align }: Props) {
    const t = useTranslations();

    const appParameters = useAppParameters();
    const locale = useLocale();

    const handleChange = useCallback(async (newLocale: string) => {
        await setLocale(newLocale);
    }, []);

    return (
        <Dropdown
            options={appParameters.supportedLocales.map(availableLocale => ({
                label: t(`general.locales.${availableLocale}`),
                extendedLabel: t(`general.languages.${availableLocale}`),
                ariaLabel: t(`general.languages.${availableLocale}`),
                value: availableLocale,
            }))}
            initialValue={locale}
            onChange={handleChange}
            align={align}
            placeholder={t('general.language')}
            aria-label={t('general.language')}
        />
    );
}
